<template>
    <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th>Date and time</th>
                    <th>Type</th>
                    <th>Employer</th>
                    <th>Campaign</th>
                    <th>Job</th>
                    <th>JA Agent</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(ats, index) in sends_to_ats" :key="index">
                    <td>{{ ats.date }}</td>
                    <td>{{ ats.app_type }}</td>
                    <td>
                        <a :href="url(`admin/employer/${ats.employer_id}/detail`)">
                            {{ ats.employer_name }}
                        </a>
                    </td>
                    <td>{{ ats.campaign_name }}</td>
                    <td>
                        job 
                        <a :href="url(`admin/jobs/${ats.job_id}`)">
                            {{ ats.job_id }}
                        </a>
                    </td>
                    <td>{{ ats.agent_name }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: [
        'sends_to_ats',
    ]
}
</script>